var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarDropDownArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 8,
  viewBox: "0 0 14 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.55771 7.69254L0.307709 1.44253C0.249639 1.38447 0.203577 1.31553 0.172151 1.23966C0.140724 1.16379 0.124548 1.08247 0.124548 1.00035C0.124548 0.918225 0.140724 0.836907 0.172151 0.761037C0.203577 0.685166 0.24964 0.616228 0.307709 0.558159C0.365777 0.50009 0.434715 0.454028 0.510586 0.422601C0.586456 0.391174 0.667774 0.374999 0.749896 0.374999C0.832018 0.374999 0.913336 0.391174 0.989206 0.422601C1.06508 0.454028 1.13402 0.50009 1.19208 0.558159L6.9999 6.36675L12.8077 0.55816C12.925 0.440884 13.084 0.375 13.2499 0.375C13.4157 0.375 13.5748 0.440884 13.6921 0.55816C13.8094 0.675435 13.8752 0.834495 13.8752 1.00035C13.8752 1.1662 13.8094 1.32526 13.6921 1.44254L7.44208 7.69254C7.38404 7.75065 7.31511 7.79675 7.23923 7.8282C7.16336 7.85965 7.08203 7.87584 6.9999 7.87584C6.91776 7.87584 6.83643 7.85965 6.76056 7.8282C6.68468 7.79674 6.61575 7.75065 6.55771 7.69254Z",
  fill: "#6B5CE8"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarDropDownArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_drop_down_arrow.e31d0fdb10a0fdaba04d7941f1fa2a9f.svg";